import * as authentication from '../modules/authentication/store/authentication.reducers';
import * as collection from '../modules/collection/store/collection.reducers';
import * as news from '../modules/news/store/news.reducers';
import {NewsState} from '../modules/news/store/news.reducers';
import * as notification from '../modules/notification/store/notification.reducers';
import {NotificationState} from '../modules/notification/store/notification.reducers';
import * as language from '../shared/language/store/language.reducers';
import {LanguageState} from '../shared/language/store/language.reducers';
import * as profile from '../modules/profile/store/profile.reducers';
import {ProfileState} from '../modules/profile/store/profile.reducers';
import * as requestMaintenance from '../modules/profile/pages/request-maintenance/store/request-maintenance.reducers';
import * as location from '../modules/location/store/location.reducers';
import {LocationState} from '../modules/location/store/location.reducers';
import * as flow from '../modules/flow/store/flow.reducers';
import {FlowState} from '../modules/flow/store/flow.reducers';
import {ActionReducerMap} from '@ngrx/store';
import {CollectionState} from '../modules/collection/collection.model';
import {AuthenticationState} from '../modules/authentication/authentication.model';
import * as collectionLayout from '../modules/collection/components/layout/store/layout.reducers';
import {LayoutState} from '../modules/collection/components/layout/layout.model';
import {routerReducer, RouterReducerState} from '@ngrx/router-store';
import {RequestMaintenanceState} from '../modules/profile/pages/request-maintenance/store/request-maintenance.model';

export interface AppState {
  [authentication.authenticationFeatureKey]: AuthenticationState,
  [collection.collectionFeatureKey]: CollectionState,
  [news.newsFeatureKey]: NewsState,
  [profile.profileFeatureKey]: ProfileState,
  [requestMaintenance.requestMaintenanceFeatureKey]: RequestMaintenanceState,
  [location.locationFeatureKey]: LocationState,
  [collectionLayout.layoutFeatureKey]: LayoutState,
  [language.languageFeatureKey]: LanguageState,
  [notification.notificationFeatureKey]: NotificationState,
  [flow.flowFeatureKey]: FlowState,
  router: RouterReducerState
}

export const appReducer: ActionReducerMap<AppState> = {
  [authentication.authenticationFeatureKey]: authentication.authenticationReducer,
  [collection.collectionFeatureKey]: collection.collectionReducer,
  [news.newsFeatureKey]: news.newsReducer,
  [profile.profileFeatureKey]: profile.profileReducer,
  [requestMaintenance.requestMaintenanceFeatureKey]: requestMaintenance.requestMaintenanceReducer,
  [location.locationFeatureKey]: location.locationReducer,
  [collectionLayout.layoutFeatureKey]: collectionLayout.layoutReducer,
  [language.languageFeatureKey]: language.languageReducer,
  [notification.notificationFeatureKey]: notification.notificationReducer,
  [flow.flowFeatureKey]: flow.flowReducer,
  router: routerReducer
}
